import React, { useState, useEffect } from 'react';
import "./style.scss";
import loader from'./loader.gif';
import blob from "./freemiumOutput.png";
import black from "./black.png";
import { BrowserRouter as Router, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SweetAlert2 from 'react-sweetalert2';
import Swal from 'sweetalert2';
import Blacklisted from '../Blacklisted';
import Explorer from '../Explorer';
import axios from "axios";
import instruction from "./instructions.png";
import Archive from '../Archive';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import ImageModal from "../ImageModal";

import { 
    ethnicityChoices,
    expressionChoices,
    compositionChoices,
    bodyTypeChoices,
    femaleModelChoices,
    haircolorChoices,
    hairstyleChoices,
    placeChoices,
    clothingsChoices,
    accessoriesChoices,
    photostylesChoices
} from '../../choices';

import withReactContent from 'sweetalert2-react-content';
const MySwal = withReactContent(Swal);

const THRESHOLD = 25;


function Playground (props) {
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth >= 1200);
  const [premiumRun, setPremiumRun] = useState (false);
  const [freeImagesDisplay, setFreeImageDisplay] = useState ("none");
  const [premiumImagesDisplay, setPremiumImagesDisplay] = useState ("none");
  const [enticement, setEnticement] = useState ("😍\u00A0Summon\u00A0your\u00A0dream\u00A0girls\u00A0here!\u00A0😍");
  const [ethnicity, setEthnicity] = useState ("");
  const [expression, setExpression] = useState ("");
  const [haircolor, setHaircolor] = useState ("");
  const [hairstyle, setHairstyle] = useState ("");
  const [place, setPlace] = useState ("");
  const [customPlace, setCustomPlace] = useState("");
  const [customPlaceDisabled, setCustomPlaceDisabled] = useState (false);

  const [customClothing, setCustomClothing] = useState("");
  const [customClothingDisabled, setCustomClothingDisabled] = useState (false);

  const [customAccessory, setCustomAccessory] = useState ("");
  const [customAccessoryDisabled, setCustomAccessoryDisabled] = useState (false);

//   const [customClothing2, setCustomClothing2] = useState("");
  const [clothings, setClothings] = useState ([]);
  const [accessories, setAccessories] = useState ([]);

  const [modelId, setModelId] = useState ("realistic-vision-v51");

  const [numInferenceSteps, setNumInferenceSteps] = useState (30);
  const [guidanceScale, setGuidanceScale] = useState (8);

  const [isTwitterAuthenticated, setIsTwitterAuthenticated] = useState(false);
  const [isBlacklisted, setIsBlacklisted] = useState(false);
  const [twitterUsername, setTwitterUsername] = useState(null);
  const [twitterUserId, setTwitterUserId] = useState(null);
  const [followedUs, setFollowedUs] = useState (false);
  const [retweetedUs, setRetweetedUs] = useState (false);

  const location = useLocation();

  const navigate = useNavigate ();
    

  const [prompt, setPrompt] = useState ("portrait of a beautiful $ETHNICITY$ woman, $EXPRESSION$ $HAIRCOLOR$ $HAIRSTYLE$ $PLACE$$CLOTHING$$ACCESSORIES$cinematic, sharp focus");

  const [negativePrompt, setNegativePrompt] = useState ("((out of frame)), ((extra fingers)), mutated hands, ((poorly drawn hands)), ((poorly drawn face)), (((mutation))), (((deformed))), (((tiling))), ((tile)), ((fleshpile)), ((ugly)), (((abstract))), blurry, ((bad anatomy)), ((bad proportions)), ((extra limbs)), cloned face, glitchy, ((extra breasts)), ((double torso)), ((extra arms)), ((extra hands)), ((mangled fingers)), ((missing breasts)), (missing lips), ((ugly face)), ((fat)), ((extra legs))");


  const [scheduler, setScheduler] = useState ("EulerAncestralDiscreteScheduler");

  const [vae, setVae] = useState (null);

  const [loraModel, setLoraModel] = useState ("more_details");

  const [loraStrength, setLoraStrength] = useState(1);

  const [tomesd, setTomesd] = useState ("yes");

  const [useKarrasSigmas, setUseKarrasSigmas] = useState ("yes");

  const [hasStartedTyping, setHasStartedTyping] = useState(false);

  const [imageLinks, setImageLinks] = useState (props.imageLinks);

  // https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/SNice.svg/1200px-SNice.svg.png

  const [firstImageUrl, setFirstImageUrl] = useState (black);
  const [secondImageUrl, setSecondImageUrl] = useState (black);
  const [thirdImageUrl, setThirdImageUrl] = useState (black);
  const [fourthImageUrl, setFourthImageUrl] = useState (black);


  const [captchaToken, setCaptchaToken] = useState('');
  const [jwtToken, setJwtToken] = useState(''); // captcha

  const [isModalOpen, setModalOpen] = useState(false);
  const [activeImage, setActiveImage] = useState('');

  
  const [composition, setComposition] = useState ("");
  const [bodyType, setBodyType] = useState ("");
  const [femaleModel, setFemaleModel] = useState ("");
  const [photostyles, setPhotostyles] = useState ([]);


  const [numRuns, setNumRuns] = useState (0);

  const [processing, setProcessing] = useState (false);

  function getRandomElements(inputArray, n) {
    // Ensure numToChoose is at least 1 and at most n, and not more than the length of the array
    let numToChoose = Math.min(inputArray.length, Math.floor(Math.random() * n) + 1);

    // Copy the inputArray to avoid modifying the original array
    let arrayCopy = [...inputArray];
    
    // The result array
    let result = [];

    // Loop to get numToChoose random elements
    for (let i = 0; i < numToChoose; i++) {
        // Get a random index
        let randomIndex = Math.floor(Math.random() * arrayCopy.length);

        // Add the element at the random index to the result array
        result.push(arrayCopy[randomIndex]);

        // Remove the element from the array copy to avoid duplicates
        arrayCopy.splice(randomIndex, 1);
    }

    return result;
}

  const randomlyChoose = () => {
    setEthnicity (getRandomElements (ethnicityChoices, 1)[0]);
    setExpression (getRandomElements (expressionChoices, 1)[0]);
    setComposition (getRandomElements (compositionChoices, 1)[0]);
    setBodyType (getRandomElements (bodyTypeChoices, 1)[0]);
    setFemaleModel (getRandomElements (femaleModelChoices, 1)[0]);
    setHaircolor (getRandomElements (haircolorChoices, 1)[0]);
    setHairstyle (getRandomElements (hairstyleChoices, 1)[0]);
    setPlace (getRandomElements (placeChoices, 1)[0]);
    setClothings (getRandomElements (clothingsChoices, 2));
    setAccessories (getRandomElements (accessoriesChoices, 2));
    setPhotostyles (getRandomElements (photostylesChoices, 2));
  }

  const clearChoices = () => {
    setEthnicity ("");
    setExpression ("");
    setComposition ("");
    setBodyType ("");
    setFemaleModel ("");
    setHaircolor ("");
    setHairstyle ("");
    setPlace ("");
    setClothings ([]);
    setAccessories ([]);
    setPhotostyles ([]);
  }

  const openFeedbackModal = () => {
    MySwal.fire({
        title: "Hope you're having fun!",
        html: `
            <div class="feedback">
                <p>We're just starting and want to know how we can make the app even better for you! <br /><strong>What else would you like to see added?</strong></p>
                <div class="radioOptions">
                    <div>
                        <input type="radio" id="chat" name="feedback" value="chat">
                        <label for="chat">Ability to chat with the girls you generate</label>
                    </div>
                    <div>
                        <input type="radio" id="poses" name="feedback" value="poses">
                        <label for="poses">More poses</label>
                    </div>
                    <div class="otherDiv">
                        <input type="radio" id="otherRadio" name="feedback" value="other">
                        <label for="otherRadio">Other: </label>
                        <input type="text" id="otherInput" disabled>
                    </div>
                </div>
            </div>
        `,
        focusConfirm: false,
        didOpen: () => {
            // Using Swal's didOpen lifecycle method to handle the "Other" radio button's change event
            document.querySelectorAll('input[name="feedback"]').forEach(el => {
                el.addEventListener('change', (e) => {
                    document.getElementById('otherInput').disabled = e.target.value !== 'other';
                });
            });
        },
        preConfirm: () => {
            const selection = document.querySelector('input[name="feedback"]:checked').value;
            const otherText = document.getElementById('otherInput').value;
        
            // Check if "Other" is selected and the input is empty
            if (selection === 'other' && otherText.trim() === '') {
                Swal.showValidationMessage(`Please provide input for the "Other" option.`);
                return;
            }
        
            return fetch('https://www.dreamgirlstudio.ai/feedback', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ selection, otherText })
            }).then(response => {
                if (!response.ok) {
                    throw new Error(response.statusText);
                }
                return response.json();
            }).catch(error => {
                Swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
        
        showCancelButton: true,
        cancelButtonText: 'Or tell us on Discord',
        confirmButtonText: 'Submit Feedback',
        showLoaderOnConfirm: true,
        // footer: '<a href="https://discord.gg/n6XwKgfduN" target="_blank" rel="noreferrer" id="footerDiscord">Or tell us on Discord</a>'
    }).then((result) => {
        if (result.value) {
            Swal.fire('Thank You!', 'Your feedback has been submitted.', 'success');
        }
        if (result.dismiss === Swal.DismissReason.cancel) {
            window.open('https://discord.gg/n6XwKgfduN', '_blank'); // Open the Discord invite link in a new tab
        }
    });
};


  const handleImageClick = (src) => {
    setActiveImage(src);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };


  useEffect (() => {
    const token = localStorage.getItem ("freemiumToken");
    if (token) {
        // check if expired. if not expired, setJwtToken. Else, remove from localstorage.


        setJwtToken (token);
    }
  }, []);


  const handleCaptchaVerification = async (token) => {
    try {
      const response = await fetch('https://www.dreamgirlstudio.ai/verify-hcaptcha', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ captchaValue: token }),
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const data = await response.json();
    //   console.log ('hcaptcha data', data);
  
      setJwtToken(data.token);
    //   setCaptchaToken(token);
      localStorage.setItem ("freemiumToken", data.token);
    } catch (error) {
      console.error('Error verifying captcha:', error);
    }
  };

  const passedCaptchaMakeRequest = async (e, req, res) => {
    document.getElementById ("mainComponent").scrollIntoView({ behavior: 'smooth' });
    e.preventDefault();
    setPremiumRun (false);

    var adjustedExpression = "";
      if (expression === "(smiling)") {
        // console.log ("(smiling) selected.");
        adjustedExpression = expression + ",";
      }

      var adjustedHaircolor = "";
      if (haircolor !== "") {
        // console.log (`${haircolor} selected`);
        adjustedHaircolor = haircolor + " hair,";
      }

      var adjustedHairstyle = "";
      if (hairstyle !== "") {
        // console.log (`${hairstyle} selected`);
        adjustedHairstyle = hairstyle + ",";
      }

      var adjustedPlace = "";
      if (place !== "") {
        // console.log (`${place} selected`);
        adjustedPlace = `at the ${place.trim ()}, `;
      }


      var filteredClothings = [];
      for (let i = 0; i < clothings.length; i++) {
        if (clothings[i].length > 0) {
            filteredClothings.push (clothings[i]);
        }
      }

      var filteredAccessories = [];
      for (let i = 0; i < accessories.length; i++) {
        if (accessories[i].length > 0) {
            filteredAccessories.push (accessories[i]);
        }
      }

      var adjustedPrompt = prompt.replaceAll ("$ETHNICITY$", ethnicity).replaceAll ("$EXPRESSION$", adjustedExpression).replaceAll ("$HAIRCOLOR$", adjustedHaircolor).replaceAll ("$HAIRSTYLE$", adjustedHairstyle).replaceAll ("$PLACE$", adjustedPlace).replaceAll ("$CLOTHING$", stringifyArray (filteredClothings)).replaceAll ("$ACCESSORIES$", stringifyArray (filteredAccessories));
      adjustedPrompt = ensureMaxSpaceBetweenWords (adjustedPrompt);
    
      document.getElementById ("loader").style.display = "block";
      setProcessing (true);

    try {
        const body = { 
            // hairColor, 
            // skinColor, 
            // boobSize, 
            // showcase, 
            ethnicity,
            expression,
            composition,
            bodyType,
            femaleModel,
            photostyles,
            haircolor,
            hairstyle,
            clothings,
            accessories,
            place,
            modelId, 
            numInferenceSteps, 
            guidanceScale, 
            // prompt, 
            // negativePrompt,
            scheduler,
            vae,
            loraModel,
            loraStrength,
            tomesd,
            useKarrasSigmas
        };

        const response = await fetch("https://www.dreamgirlstudio.ai/runFreemiumApiSdxl", {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${jwtToken}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify (body)
        })
        .then(async responseData => {
            if (!responseData.ok) {
                toast.error ("Something went wrong. Please try again. Sorry about that");
                throw new Error ("Network response was not ok!");
            }
            
            const data = await responseData.json ();
            // console.log ("data", data);

            if (data === "Invalid token") {
                toast.error ("Please complete the CAPTCHA before creating your Dream Girls.");
                document.getElementById ("doCaptcha").scrollIntoView({ behavior: 'smooth' });
                return;
            }
            setFirstImageUrl (data.imageUrl);
            setSecondImageUrl (blob);
            setThirdImageUrl (blob);
            setFourthImageUrl (blob);
            setEnticement ("Showing 1 of 4 images (Free Tier)");
            setPremiumImagesDisplay ("flex")
            setFreeImageDisplay ("flex");
            

            setNumRuns (prevNumRan => prevNumRan + 1);
            if (numRuns === 1) {
                setTimeout (() => openFeedbackModal (), 2000);
            }
        });
    } catch (err) {
        console.error (err.message);
        setFirstImageUrl ("https://t4.ftcdn.net/jpg/03/08/92/49/360_F_308924911_jsWAfFOqdSGglzvF7zcNcXIo06eS7Wch.jpg");
        setSecondImageUrl ("https://t4.ftcdn.net/jpg/03/08/92/49/360_F_308924911_jsWAfFOqdSGglzvF7zcNcXIo06eS7Wch.jpg");
        setThirdImageUrl ("https://t4.ftcdn.net/jpg/03/08/92/49/360_F_308924911_jsWAfFOqdSGglzvF7zcNcXIo06eS7Wch.jpg");
        setFourthImageUrl ("https://t4.ftcdn.net/jpg/03/08/92/49/360_F_308924911_jsWAfFOqdSGglzvF7zcNcXIo06eS7Wch.jpg");
        toast.error ("Something went wrong. Please try again. Sorry about that.");
        // toast.error (err.message);
    }
    document.getElementById ("loader").style.display = "none";
    setProcessing (false);
  }


  const handleEthnicityClick = (value) => {
    if (ethnicity === value) {
      setEthnicity (""); // Deselect the radio button
    } else {
      setEthnicity (value); // Select the radio button
    }
  };

  const handleExpressionClick = (value) => {
    if (expression === value) {
      setExpression (""); // Deselect the radio button
    } else {
      setExpression (value); // Select the radio button
    }
  };

  const handleHaircolorClick = (value) => {
    if (haircolor === value) {
      setHaircolor (""); // Deselect the radio button
    } else {
      setHaircolor (value); // Select the radio button
    }
  };

  const handleHairstyleClick = (value) => {
    if (hairstyle === value) {
      setHairstyle (""); // Deselect the radio button
    } else {
      setHairstyle (value); // Select the radio button
    }
  };

  const handleCompositionClick = (value) => {
    if (composition === value) {
      setComposition (""); // Deselect the radio button
    } else {
      setComposition (value); // Select the radio button
    }
  };

  const handleBodyTypeClick = (value) => {
    if (bodyType === value) {
      setBodyType (""); // Deselect the radio button
    } else {
      setBodyType (value); // Select the radio button
    }
  };

  const handleFemaleModelClick = (value) => {
    if (femaleModel === value) {
      setFemaleModel (""); // Deselect the radio button
    } else {
      setFemaleModel (value); // Select the radio button
    }
  };

  function handlePhotostylesChange (event) {
    // selfie, polaroid
    const value = event.target.value;

    if (event.target.checked) {
      setPhotostyles ([...photostyles, value]);
    } else {
      setPhotostyles (photostyles.filter(item => item !== value));
    }
}


  const handlePlaceClick = (value) => {
    setCustomPlace ("");
    setHasStartedTyping (false);

    if (place === value) {
      setPlace (""); // Deselect the radio button
    } else {
      setPlace (value); // Select the radio button
    }
  };

  function ensureMaxSpaceBetweenWords(inputString) {
    // Split the input string into an array of words
    const words = inputString.split(/\s+/);

    // Join the words with a single space between them to form the result string
    const resultString = words.join(' ');

    return resultString;
    }


  const handleCustomPlaceChange = (e) => {
    const value = e.target.value;
    const words = value.split(' ').filter(Boolean);
    const wordCount = words.length;
    const lastChar = value.charAt(value.length - 1);
    const isAlphanumeric = /^[a-z0-9]+$/i.test(lastChar);
    const isSpace = lastChar === ' ';
    const isDeleting = value.length < customPlace.length;

    if (isDeleting || (isAlphanumeric || (isSpace && value.charAt(value.length - 2) !== ' ')) 
        && value.length <= 25
        && (wordCount <= 2 || (wordCount === 2 && isSpace))) {
        setCustomPlace(value);
        setPlace(value); // When custom place changes, update the selected place
    } else if (!isDeleting) {
        e.target.value = customPlace;
        return;
    }

    if (value.length > 0) {
        setHasStartedTyping(true);
    } else if (value.length === 0) {
        setHasStartedTyping(false);
    }
};


function handleCustomClothingChange (e) {
    const value = e.target.value;
    const words = value.split(' ').filter(Boolean);
    const wordCount = words.length;
    const lastChar = value.charAt(value.length - 1);
    const isAlphanumeric = /^[a-z0-9]+$/i.test(lastChar);
    const isSpace = lastChar === ' ';
    const isDeleting = value.length < customClothing.length;

    if (isDeleting || (isAlphanumeric || (isSpace && value.charAt(value.length - 2) !== ' ')) 
        && value.length <= 25
        && (wordCount <= 2 || (wordCount === 2 && isSpace))) {
        setCustomClothing(value);
    } else if (!isDeleting) {
        e.target.value = customClothing;
        return;
    }
}

  function handleClothingsChange (event) {
    const value = event.target.value;

    if (event.target.checked) {
      setClothings ([...clothings, value]);
    } else {
      setClothings (clothings.filter(item => item !== value));
    }
    // console.log ("clothings", clothings);
  }

  function handleAccessoriesChange (event) {
    const value = event.target.value;

    if (event.target.checked) {
      setAccessories ([...accessories, value]);
    } else {
      setAccessories (accessories.filter(item => item !== value));
    }
  }

  function handleCustomAccessoryChange (e) {
    const value = e.target.value;
    const words = value.split(' ').filter(Boolean);
    const wordCount = words.length;
    const lastChar = value.charAt(value.length - 1);
    const isAlphanumeric = /^[a-z0-9]+$/i.test(lastChar);
    const isSpace = lastChar === ' ';
    const isDeleting = value.length < customAccessory.length;

    if (isDeleting || (isAlphanumeric || (isSpace && value.charAt(value.length - 2) !== ' ')) 
        && value.length <= 25
        && (wordCount <= 2 || (wordCount === 2 && isSpace))) {
        setCustomAccessory(value);
    } else if (!isDeleting) {
        e.target.value = customAccessory;
        return;
    }
}

  function stringifyArray (array) {
    if (array.length > 0) {
        return array.join(', ').trim() + ", ";
    } else {
        return "";
    }
  }

//   useEffect(() => {
//     Swal.fire({
//         title: 'How do I use this? Easy!',
//         html: `Just <strong>click the big DREAM button</strong> or <strong>customize your dream girls first</strong> by choosing their ethnicity, hair color, etc., to your liking!<img src=${instruction} class='instruction' style='margin-top: 1em' />`,

//         confirmButtonColor: '#3085d6',
//         confirmButtonText: 'Got it!',
//     });
//     // openFeedbackModal ();

//     const handleResize = () => {
//       setIsWideScreen (window.innerWidth > 677);
//     };

//     window.addEventListener('resize', handleResize);

//     // Cleanup the event listener on component unmount
//     return () => {
//       window.removeEventListener('resize', handleResize);
//     };
//   }, []);
 

  const fetchArchiveData = async () => {
    if (props.account) {
      try {
          const response = await fetch(`https://www.dreamgirlstudio.ai/archiveLinks/${props.account.toLowerCase()}`);
        //   console.log ("response", response);
          const result = await response.json();
        //   console.log ("result", result);
          setImageLinks(result.images_links);
        //   console.log("imageLinks from Premium", result.images_links);
        } catch (err) {
          console.error(err.message);
        }
    }

  };

  useEffect(() => {
    const fetchArchiveData = async () => {
      if (props.account) {
        try {
            const response = await fetch(`https://www.dreamgirlstudio.ai/archiveLinks/${props.account.toLowerCase()}`);
            // console.log ("response", response);
            const result = await response.json();
            // console.log ("result", result);
            setImageLinks(result.images_links);
            // console.log("imageLinks from Premium", result.images_links);
          } catch (err) {
            console.error(err.message);
          }
      }

    };
  
    fetchArchiveData();
  }, [props.account]);







  return (
    <section id="mainComponent">

        {/* <Explorer /> */}
      {/* <div className="premiumWelcome">
            <p>You are on Premium mode. With Premium mode, you can enjoy:</p>
            <ul>
                <li>• Adding nudity</li>
                <li>• <a href="#">Accessing a list of your previous girls</a></li>
            </ul>
      </div> */}
      <div className="goPremium">

      <h2><a href="/premium" target="_blank" rel="noreferrer">Unlock Premium Mode</a></h2>
        <table>
            <tr>
                <td>
                    • 4 Results per creation
                    <br />
                    • Archive created images
                </td>
                <td>
                    • Pro options (nude, custom inputs, etc.)
                    <br />
                    • Remove CAPTCHA & watermark
                </td>
            </tr>
        </table>
        <p>*We are looking to launch the sale of $DREAM tokens in Q4 2023. Please <a href="https://twitter.com/dream_girl_ai" target="_blank" rel="noreferrer">follow us on Twitter</a> and/or join our <a href="https://t.me/dreamgirlstudioportal" target="_blank" rel="noreferrer">Telegram group</a> for the latest updates and feature requests. In the meantime, <u>make your girlfriends FOR FREE</u> and give us any and all feedback!</p>
      </div>


      {/* <h3>$DREAM balance: {props.tokenBalance}</h3> */}
      <h3 className="enticement">{enticement}</h3>
      {/* <ToastContainer /> */}
      <img src={loader} id="loader" alt="loader" />
      {isWideScreen || premiumRun ? (
        <div id="output" className="output">
          <img 
            src={firstImageUrl} 
            style={{display: freeImagesDisplay}} 
            alt="first" 
            onClick={() => handleImageClick(firstImageUrl)}
            className="outputImage"
          />
          <img 
            src={secondImageUrl} 
            style={{display: premiumImagesDisplay}} 
            alt="second"
            onClick={() => handleImageClick(secondImageUrl)}
            className="outputImage"
          />
          <img 
            src={thirdImageUrl} 
            style={{display: premiumImagesDisplay}} 
            alt="third" 
            onClick={() => handleImageClick(thirdImageUrl)}
            className="outputImage"
          />
          <img 
            src={fourthImageUrl} 
            style={{display: premiumImagesDisplay}} 
            alt="fourth" 
            onClick={() => handleImageClick(fourthImageUrl)}
            className="outputImage"
          />
        </div>
      ) : (
        <div id="output" className="output">
          <img 
            src={firstImageUrl} 
            style={{display: freeImagesDisplay}} 
            alt="first" 
            onClick={() => handleImageClick(firstImageUrl)}
            className="outputImage"
          />
        </div>
      )}

      {isModalOpen && <ImageModal src={activeImage} onClose={handleCloseModal} />}
      <hr />

      <div className="options">
        <button id="randomizeButton" onClick={randomlyChoose}>Randomize!</button>
        <button id="clearButton" onClick={clearChoices}>Clear choices</button>
      </div>
    
      <form>
        <h2>Ethnicity <span className="guide">(Choose 1)</span></h2>
        <div className="ethnicityDiv">
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Russian"
                    checked={ethnicity === 'Russian'}
                    onChange={e => {
                        setEthnicity (e.target.value);
                        // console.log (e.target.value);
                        // document.getElementsByClassName ("ethnicityOption").style.background = "inherit";
                        // e.target.parentNode.parentNode.style.background = "green";
                    }}
                    onClick={() => handleEthnicityClick ("Russian")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Russian</h3>
                    </div>
                </span>
            </label>

            <label className="custom-radio">
                <input
                    type="radio"
                    value="British"
                    checked={ethnicity === 'British'}
                    onChange={e => {
                        setEthnicity (e.target.value);
                        // console.log (e.target.value);
                    }}
                    onClick={() => handleEthnicityClick ("British")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>British</h3>
                    </div>
                </span>
            </label>

            <label className="custom-radio">
                <input
                    type="radio"
                    value="Brazilian"
                    checked={ethnicity === 'Brazilian'}
                    onChange={e => {
                        setEthnicity (e.target.value);
                        // console.log (e.target.value);
                    }}
                    onClick={() => handleEthnicityClick ("Brazilian")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Brazilian</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Chinese"
                    checked={ethnicity === 'Chinese'}
                    onChange={e => {
                        setEthnicity (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleEthnicityClick ("Chinese")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Chinese</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Korean"
                    checked={ethnicity === 'Korean'}
                    onChange={e => {
                        setEthnicity (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleEthnicityClick ("Korean")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Korean</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Japanese"
                    checked={ethnicity === 'Japanese'}
                    onChange={e => {
                        setEthnicity (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleEthnicityClick ("Japanese")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Japanese</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Filipino"
                    checked={ethnicity === 'Filipino'}
                    onChange={e => {
                        setEthnicity (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleEthnicityClick ("Filipino")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Filipino</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Spanish"
                    checked={ethnicity === 'Spanish'}
                    onChange={e => {
                        setEthnicity (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleEthnicityClick ("Spanish")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Spanish</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Mexican"
                    checked={ethnicity === 'Mexican'}
                    onChange={e => {
                        setEthnicity (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleEthnicityClick ("Mexican")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Mexican</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Latina"
                    checked={ethnicity === 'Latina'}
                    onChange={e => {
                        setEthnicity (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleEthnicityClick ("Latina")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Latina</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="French"
                    checked={ethnicity === 'French'}
                    onChange={e => {
                        setEthnicity (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleEthnicityClick ("French")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>French</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Swedish"
                    checked={ethnicity === 'Swedish'}
                    onChange={e => {
                        setEthnicity (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleEthnicityClick ("Swedish")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Swedish</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Kazakh"
                    checked={ethnicity === 'Kazakh'}
                    onChange={e => {
                        setEthnicity (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleEthnicityClick ("Kazakh")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Kazakh</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Jewish"
                    checked={ethnicity === 'Jewish'}
                    onChange={e => {
                        setEthnicity (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleEthnicityClick ("Jewish")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Jewish</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Arabic"
                    checked={ethnicity === 'Arabic'}
                    onChange={e => {
                        setEthnicity (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleEthnicityClick ("Arabic")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Arabic</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Armenian"
                    checked={ethnicity === 'Armenian'}
                    onChange={e => {
                        setEthnicity (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleEthnicityClick ("Armenian")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Armenian</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="American"
                    checked={ethnicity === 'American'}
                    onChange={e => {
                        setEthnicity (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleEthnicityClick ("American")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>American</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Indian"
                    checked={ethnicity === 'Indian'}
                    onChange={e => {
                        setEthnicity (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleEthnicityClick ("Indian")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Indian</h3>
                    </div>
                </span>
            </label>
        </div>
        <h2>Expression <span className="guide">(Choose 1)</span></h2>
        <div className="expressionDiv">
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Neutral"
                    checked={expression === 'Neutral'}
                    onChange={e => {
                        setExpression (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleExpressionClick('Neutral')}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Neutral</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Normal"
                    checked={expression === 'Normal'}
                    onChange={e => {
                        setExpression (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleExpressionClick ('Normal')}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Normal</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Sad"
                    checked={expression === 'Sad'}
                    onChange={e => {
                        setExpression (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleExpressionClick ('Sad')}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Sad</h3>
                    </div>
                </span>
            </label>
        </div>
        <h2>Composition <span className="guide">(Choose 1)</span></h2>
        <div className="compositionDiv">
            <label className="custom-radio">
                <input
                    type="radio"
                    value="(full body)"
                    checked={composition === '(full body)'}
                    onChange={e => {
                        setComposition (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleCompositionClick('(full body)')}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Full&nbsp;Body</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Portrait"
                    checked={composition === 'Portrait'}
                    onChange={e => {
                        setComposition (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleCompositionClick('Portrait')}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Portrait</h3>
                    </div>
                </span>
            </label>
        </div>
        <h2>Body Type <span className="guide">(Choose 1)</span></h2>
        <div className="bodyTypeDiv">
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Average"
                    checked={bodyType === 'Average'}
                    onChange={e => {
                        setBodyType (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleBodyTypeClick ('Average')}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Average</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Skinny"
                    checked={bodyType === 'Skinny'}
                    onChange={e => {
                        setBodyType (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleBodyTypeClick ('Skinny')}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Skinny</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Fat"
                    checked={bodyType === 'Fat'}
                    onChange={e => {
                        setBodyType (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleBodyTypeClick ('Fat')}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Fat</h3>
                    </div>
                </span>
            </label>
        </div>
        <h2>Female Model <span className="guide">(Choose 1)</span></h2>
        <div className="femaleModelDiv">
            <label className="custom-radio">
                <input
                    type="radio"
                    value="College Girl"
                    checked={femaleModel === 'College Girl'}
                    onChange={e => {
                        setFemaleModel (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleFemaleModelClick ('College Girl')}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>College&nbsp;Girl</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Supermodel"
                    checked={femaleModel === 'Supermodel'}
                    onChange={e => {
                        setFemaleModel (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleFemaleModelClick ('Supermodel')}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Supermodel</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Woman"
                    checked={femaleModel === 'Woman'}
                    onChange={e => {
                        setFemaleModel (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleFemaleModelClick ('Woman')}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Woman</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Athlete"
                    checked={femaleModel === 'Athlete'}
                    onChange={e => {
                        setFemaleModel (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleFemaleModelClick ('Athlete')}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Athlete</h3>
                    </div>
                </span>
            </label>
        </div>
        <h2>Hair Color <span className="guide">(Choose 1)</span></h2>
        <div className="haircolorDiv">
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Blonde"
                    checked={haircolor === 'Blonde'}
                    onChange={e => {
                        setHaircolor (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleHaircolorClick("Blonde")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Blonde</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Brown"
                    checked={haircolor === 'Brown'}
                    onChange={e => {
                        setHaircolor (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleHaircolorClick("Brown")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Brown</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Black"
                    checked={haircolor === 'Black'}
                    onChange={e => {
                        setHaircolor (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleHaircolorClick("Black")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Black</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Red"
                    checked={haircolor === 'Red'}
                    onChange={e => {
                        setHaircolor (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleHaircolorClick("Red")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Red</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Blue"
                    checked={haircolor === 'Blue'}
                    onChange={e => {
                        setHaircolor (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleHaircolorClick("Blue")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Blue</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Green"
                    checked={haircolor === 'Green'}
                    onChange={e => {
                        setHaircolor (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleHaircolorClick("Green")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Green</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="White"
                    checked={haircolor === 'White'}
                    onChange={e => {
                        setHaircolor (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleHaircolorClick("White")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>White</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Purple"
                    checked={haircolor === 'Purple'}
                    onChange={e => {
                        setHaircolor (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleHaircolorClick("Purple")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Purple</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Rainbow"
                    checked={haircolor === 'Rainbow'}
                    onChange={e => {
                        setHaircolor (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleHaircolorClick("Rainbow")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Rainbow</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Orange"
                    checked={haircolor === 'Orange'}
                    onChange={e => {
                        setHaircolor (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleHaircolorClick("Orange")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Orange</h3>
                    </div>
                </span>
            </label>
        </div>

        <h2>Hair Style <span className="guide">(Choose 1)</span></h2>
        <div className="hairstyleDiv">
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Bangs"
                    checked={hairstyle === 'Bangs'}
                    onChange={e => {
                        setHairstyle (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleHairstyleClick ("Bangs")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Bangs</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Ponytail"
                    checked={hairstyle === 'Ponytail'}
                    onChange={e => {
                        setHairstyle (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleHairstyleClick ("Ponytail")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Ponytail</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Straight hair"
                    checked={hairstyle === 'Straight hair'}
                    onChange={e => {
                        setHairstyle (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleHairstyleClick ("Straight hair")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Straight</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Short hair"
                    checked={hairstyle === 'Short hair'}
                    onChange={e => {
                        setHairstyle (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleHairstyleClick ("Short hair")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Short</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Braids"
                    checked={hairstyle === 'Braids'}
                    onChange={e => {
                        setHairstyle (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleHairstyleClick ("Braids")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Braids</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Long hair"
                    checked={hairstyle === 'Long hair'}
                    onChange={e => {
                        setHairstyle (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleHairstyleClick ("Long hair")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Long</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Pixie hairstyle"
                    checked={hairstyle === 'Pixie hairstyle'}
                    onChange={e => {
                        setHairstyle (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleHairstyleClick ("Pixie hairstyle")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Pixie</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Wild hairstyle"
                    checked={hairstyle === 'Wild hairstyle'}
                    onChange={e => {
                        setHairstyle (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handleHairstyleClick ("Wild hairstyle")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Wild</h3>
                    </div>
                </span>
            </label>
        </div>
        <h2>Place <span className="guide">(Choose 1)</span></h2>
        <div className="placeDiv">
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Beach"
                    checked={place === 'Beach'}
                    onChange={e => {
                        setPlace (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handlePlaceClick ("Beach")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Beach</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Pool"
                    checked={place === 'Pool'}
                    onChange={e => {
                        setPlace (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handlePlaceClick ("Pool")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Pool</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Street"
                    checked={place === 'Street'}
                    onChange={e => {
                        setPlace (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handlePlaceClick ("Street")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Street</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Bedroom"
                    checked={place === 'Bedroom'}
                    onChange={e => {
                        setPlace (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handlePlaceClick ("Bedroom")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Bedroom</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Desert"
                    checked={place === 'Desert'}
                    onChange={e => {
                        setPlace (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handlePlaceClick ("Desert")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Desert</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Mountains"
                    checked={place === 'Mountains'}
                    onChange={e => {
                        setPlace (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handlePlaceClick ("Mountains")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Mountains</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Jungle"
                    checked={place === 'Jungle'}
                    onChange={e => {
                        setPlace (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handlePlaceClick ("Jungle")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Jungle</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Snow"
                    checked={place === 'Snow'}
                    onChange={e => {
                        setPlace (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handlePlaceClick ("Snow")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Snow</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Church"
                    checked={place === 'Church'}
                    onChange={e => {
                        setPlace (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handlePlaceClick ("Church")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Church</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Farm"
                    checked={place === 'Farm'}
                    onChange={e => {
                        setPlace (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handlePlaceClick ("Farm")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Farm</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Bathroom"
                    checked={place === 'Bathroom'}
                    onChange={e => {
                        setPlace (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handlePlaceClick ("Bathroom")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Bathroom</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Woods"
                    checked={place === 'Woods'}
                    onChange={e => {
                        setPlace (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handlePlaceClick ("Woods")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Woods</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Mall"
                    checked={place === 'Mall'}
                    onChange={e => {
                        setPlace (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handlePlaceClick ("Mall")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Mall</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Airplane"
                    checked={place === 'Airplane'}
                    onChange={e => {
                        setPlace (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handlePlaceClick ("Airplane")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Airplane</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Car"
                    checked={place === 'Car'}
                    onChange={e => {
                        setPlace (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handlePlaceClick ("Car")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Car</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Bar"
                    checked={place === 'Bar'}
                    onChange={e => {
                        setPlace (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handlePlaceClick ("Bar")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Bar</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="radio"
                    value="Festival"
                    checked={place === 'Festival'}
                    onChange={e => {
                        setPlace (e.target.value);
                        console.log (e.target.value);
                    }}
                    onClick={() => handlePlaceClick ("Festival")}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Festival</h3>
                    </div>
                </span>
            </label>
            <div className="customPlaceDiv">
                <label>
                    {props.tokenBalance >= THRESHOLD ? (
                        <input
                            type="text"
                            value={customPlace}
                            placeholder="🔐&nbsp;CUSTOM&nbsp;🔐"
                            onChange={handleCustomPlaceChange}
                            style={{
                                backgroundColor: hasStartedTyping ? '#38FAFB' : '#000',
                                color: hasStartedTyping ? 'black' : 'white',
                            }}
                        />
                    ) : (
                        <input
                            disabled={customPlaceDisabled}
                            onClick={() => {toast.error (`You need to hold at least ${THRESHOLD} $DREAM tokens or have an active subscription to unlock this Premium feature.`, {autoClose: 10000}); setCustomPlaceDisabled (true);}}
                            placeholder="🔒&nbsp;CUSTOM&nbsp;🔒"

                        />
                    )}

                </label>
            </div>
            <label className="custom-radio" style={{display: "none"}}>
                    <input
                        type="radio"
                        value={customPlace}
                        checked={place === customPlace && customPlace !== ""}
                        onChange={() => {}} // keep this empty as we're controlling the input with customPlace state
                        onClick={() => handlePlaceClick(customPlace)}
                    />
                    <span className="radio-btn" style={{width: "340px"}}>
                        <div className="hobbies-icon">
                            <h3>{customPlace || "Custom"}</h3>
                        </div>
                    </span>
                </label>
        </div>
        <h2>Clothings <span className="guide">(Choose 1 / many)</span></h2>
        <div className="clothingsDiv">
            <label className="custom-radio">
                {props.tokenBalance >= THRESHOLD ? (
                    <input
                        type="checkbox"
                        value="topless, nude"
                        checked={clothings.includes('topless, nude')}
                        onChange={handleClothingsChange}
                    />
                ) : (
                    <input
                        onClick={() => toast.error (`You need to hold at least ${THRESHOLD} $DREAM tokens or have an active subscription to unlock this Premium feature.`, {autoClose: 10000})}
                    />
                )}
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3 style={{display: "flex"}}>{props.tokenBalance >= THRESHOLD ? <span>🔐&nbsp;</span> : <span>🔒&nbsp;</span>}Nude{props.tokenBalance >= THRESHOLD ? <span>&nbsp;🔐</span> : <span>&nbsp;🔒</span>}</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Bikini"
                    checked={clothings.includes ('Bikini')}
                    onChange={handleClothingsChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Bikini</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Jacket"
                    checked={clothings.includes('Jacket')}
                    onChange={handleClothingsChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Jacket</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Blouse"
                    checked={clothings.includes('Blouse')}
                    onChange={handleClothingsChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Blouse</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Tank Top"
                    checked={clothings.includes('Tank Top')}
                    onChange={handleClothingsChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Tank&nbsp;Top</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Sports Bra"
                    checked={clothings.includes('Sports Bra')}
                    onChange={handleClothingsChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Sports&nbsp;Bra</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Lingerie"
                    checked={clothings.includes('Lingerie')}
                    onChange={handleClothingsChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Lingerie</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Robot Suit"
                    checked={clothings.includes('Robot Suit')}
                    onChange={handleClothingsChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Robot&nbsp;Suit</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Dress"
                    checked={clothings.includes('Dress')}
                    onChange={handleClothingsChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Dress</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Fur Coat"
                    checked={clothings.includes('Fur Coat')}
                    onChange={handleClothingsChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Fur&nbsp;Coat</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Corset"
                    checked={clothings.includes('Corset')}
                    onChange={handleClothingsChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Corset</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Military Jacket"
                    checked={clothings.includes('Military Jacket')}
                    onChange={handleClothingsChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Military&nbsp;Jacket</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Bomber Jacket"
                    checked={clothings.includes('Bomber Jacket')}
                    onChange={handleClothingsChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Bomber&nbsp;Jacket</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Pajamas"
                    checked={clothings.includes('Pajamas')}
                    onChange={handleClothingsChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Pajamas</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Medieval Armor"
                    checked={clothings.includes('Medieval Armor')}
                    onChange={handleClothingsChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Medieval&nbsp;Armor</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Kimono"
                    checked={clothings.includes('Kimono')}
                    onChange={handleClothingsChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Kimono</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Superhero Outfit"
                    checked={clothings.includes('Superhero Outfit')}
                    onChange={handleClothingsChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Superhero</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Hijab"
                    checked={clothings.includes('Hijab')}
                    onChange={handleClothingsChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Hijab</h3>
                    </div>
                </span>
            </label>
            {props.tokenBalance >= THRESHOLD ? (
                <input
                className="customClothing"
                type="text"
                placeholder="🔐&nbsp;CUSTOM&nbsp;🔐"
                value={customClothing}
                onChange={handleCustomClothingChange}
                // onChange={event => {
                // setCustomClothing(event.target.value);
                // console.log (customClothing);
                // }}
                style={{
                    backgroundColor: customClothing.length > 0 ? '#38FAFB' : '#000',
                    color: customClothing.length > 0 ? 'black' : 'white'
                }}
            />
            ) : (
                <input
                    className="customClothing"
                    disabled={customClothingDisabled}
                    onClick={() => {toast.error (`You need to hold at least ${THRESHOLD} $DREAM tokens or have an active subscription to unlock this Premium feature.`, {autoClose: 10000}); setCustomClothingDisabled (true);}}
                    placeholder="🔒&nbsp;CUSTOM&nbsp;🔒"
                />
            )}
            
            {/* <input
                className="customClothing"
                type="text"
                placeholder="CUSTOM"
                value={customClothing2}
                onChange={handleCustomClothing2Change}
                style={{
                    backgroundColor: customClothing2.length > 0 ? '#38FAFB' : '#000',
                    color: customClothing2.length > 0 ? 'black' : 'white'
                }}
            /> */}
        </div>
        <h2>Accessories <span className="guide">(Choose 1 / many)</span></h2>
        <div className="accessoriesDiv">
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Scarf"
                    checked={accessories.includes('Scarf')}
                    onChange={handleAccessoriesChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Scarf</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Necklace"
                    checked={accessories.includes('Necklace')}
                    onChange={handleAccessoriesChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Necklace</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Choker"
                    checked={accessories.includes('Choker')}
                    onChange={handleAccessoriesChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Choker</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Earrings"
                    checked={accessories.includes('Earrings')}
                    onChange={handleAccessoriesChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Earrings</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Tattoos"
                    checked={accessories.includes('Tattoos')}
                    onChange={handleAccessoriesChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Tattoos</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Lipstick"
                    checked={accessories.includes('Lipstick')}
                    onChange={handleAccessoriesChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Lipstick</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Sunglasses"
                    checked={accessories.includes('Sunglasses')}
                    onChange={handleAccessoriesChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Sunglasses</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Surgical Mask"
                    checked={accessories.includes('Surgical Mask')}
                    onChange={handleAccessoriesChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Surgical&nbsp;Mask</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Baseball Cap"
                    checked={accessories.includes('Baseball Cap')}
                    onChange={handleAccessoriesChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Baseball&nbsp;Cap</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Beret"
                    checked={accessories.includes('Beret')}
                    onChange={handleAccessoriesChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Beret</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Veil"
                    checked={accessories.includes('Veil')}
                    onChange={handleAccessoriesChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Veil</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Headphones"
                    checked={accessories.includes('Headphones')}
                    onChange={handleAccessoriesChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Headphones</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Headband"
                    checked={accessories.includes('Headband')}
                    onChange={handleAccessoriesChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Headband</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Beanie"
                    checked={accessories.includes('Beanie')}
                    onChange={handleAccessoriesChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Beanie</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Santa Hat"
                    checked={accessories.includes('Santa Hat')}
                    onChange={handleAccessoriesChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Santa&nbsp;Hat</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Cowboy Hat"
                    checked={accessories.includes('Cowboy Hat')}
                    onChange={handleAccessoriesChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Cowboy&nbsp;Hat</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Sunhat"
                    checked={accessories.includes('Sunhat')}
                    onChange={handleAccessoriesChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Sunhat</h3>
                    </div>
                </span>
            </label>
            {props.tokenBalance >= THRESHOLD ? (
                <input
                    className="customAccessory"
                    type="text"
                    placeholder="🔐&nbsp;CUSTOM&nbsp;🔐"
                    value={customAccessory}
                    onChange={handleCustomAccessoryChange}
                    // onChange={event => {
                    // setCustomClothing(event.target.value);
                    // console.log (customAccessory);
                    // }}
                    style={{
                        backgroundColor: customAccessory.length > 0 ? '#38FAFB' : '#000',
                        color: customAccessory.length > 0 ? 'black' : 'white'
                    }}
                />
            ) : (
                <input
                    className="customAccessory"
                    disabled={customAccessoryDisabled}
                    onClick={() => {toast.error (`You need to hold at least ${THRESHOLD} $DREAM tokens or have an active subscription to unlock this Premium feature.`, {autoClose: 10000}); setCustomAccessoryDisabled (true);}}
                    placeholder="🔒&nbsp;CUSTOM&nbsp;🔒"
                />
            )}

        </div>
        <h2>Photostyles <span className="guide">(Choose 1 / many)</span></h2>
        <div className="photostylesDiv">
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Selfie"
                    checked={photostyles.includes('Selfie')}
                    onChange={handlePhotostylesChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Selfie</h3>
                    </div>
                </span>
            </label>
            <label className="custom-radio">
                <input
                    type="checkbox"
                    value="Polaroid"
                    checked={photostyles.includes('Polaroid')}
                    onChange={handlePhotostylesChange}
                />
                <span className="radio-btn">
                    {/* <i className="las la-check"></i> */}
                    <div className="hobbies-icon">
                    {/* <i className="las la-ellipsis-h"></i> */}
                    <h3>Polaroid</h3>
                    </div>
                </span>
            </label>
        </div>
        {/* <SweetAlert2 {...swalProps}
                didOpen={() => {
                    // run when swal is opened...
                }}
                didClose={() => {
                    // run when swal is closed...
                }}
                onConfirm={result => {
                    // run when clieked in confirm and promise is resolved...
                }}
                onError={error => {
                    // run when promise rejected...
                }}
                onResolve={result => {
                    // run when promise is resolved...
                }}
            /> */}

        <button onClick={passedCaptchaMakeRequest} disabled={processing}>Dream</button>
        <div className="captchaContainer">
        <div>
          <HCaptcha
            // sitekey="10000000-ffff-ffff-ffff-000000000001"
            sitekey="056ea974-5a78-4968-a7f0-8d69886103e7"
            onVerify={handleCaptchaVerification}
            id="doCaptcha"
          />
        </div>
    </div>
      </form>
    </section>
  );
}

export default Playground;


